// Mapeamento de status para labels
const STATUS_LABEL_MAP: { [key: string]: string } = {
  Able: 'Apto a operar',
  Expired: 'Expirado',
  NoLimit: 'Sem limite',
  Monitoring: 'Monitorar',
  NextToExpire: 'Próx. a expirar',
  PendingIntegration: 'Não Integrado',
  SendingForAnalysis: 'Env. análise',
  OnGoing: 'Em análise',
  PendingDocument: 'Pendente',
};

// Mapeamento de status para classes CSS
const STATUS_CLASS_MAP: { [key: string]: string } = {
  Able: 'status-approved',
  Expired: 'status-expired',
  NoLimit: 'status-expired',
  Monitoring: 'status-pending',
  NextToExpire: 'status-pending',
  PendingIntegration: 'status-waiting',
  SendingForAnalysis: 'status-pending',
  OnGoing: 'status-approved',
  PendingDocument: 'status-pending',
};

// Mapeamento de situação para ícones
const SITUATION_ICON_MAP: { [key: string]: string } = {
  // Mapeamento por valor do enum (número)
  '1': 'assets/icons/situation/clock-time.svg',
  '4': 'assets/icons/situation/checkmark-done.svg',
  '5': 'assets/icons/situation/delete-button.svg',
  '6': 'assets/icons/situation/circle-delete.svg',
  '7': 'assets/icons/situation/loading-rotate.svg',
  '8': 'assets/icons/situation/clock-time.svg',
  '9': 'assets/icons/situation/warning.svg',
  '10': 'assets/icons/situation/news-paper.svg',
  // Mapeamento por nome do enum (string)
  WAIT: 'assets/icons/situation/clock-time.svg',
  APPROVED: 'assets/icons/situation/checkmark-done.svg',
  REPROVED: 'assets/icons/situation/delete-button.svg',
  CANCELED: 'assets/icons/situation/circle-delete.svg',
  IN_PROGRESS_REGISTER_MANAGEMENT: 'assets/icons/situation/loading-rotate.svg',
  SENDING_REGISTRATION_REGISTER_MANAGEMENT:
    'assets/icons/situation/clock-time.svg',
  PENDING: 'assets/icons/situation/warning.svg',
  AWAITING_CONSENT: 'assets/icons/situation/news-paper.svg',
};

// Mapeamento de situação para labels
const SITUATION_LABEL_MAP: { [key: string]: string } = {
  // Mapeamento por valor do enum (número)
  '1': 'Em andamento',
  '4': 'Aprovado',
  '5': 'Reprovado',
  '6': 'Cancelado',
  '7': 'Em andamento',
  '8': 'Em análise',
  '9': 'Com pendência',
  '10': 'Aceite de termos',
  // Mapeamento por nome do enum (string)
  WAIT: 'Em andamento',
  APPROVED: 'Aprovado',
  REPROVED: 'Reprovado',
  CANCELED: 'Cancelado',
  IN_PROGRESS_REGISTER_MANAGEMENT: 'Em andamento',
  SENDING_REGISTRATION_REGISTER_MANAGEMENT: 'Em análise',
  PENDING: 'Com pendência',
  AWAITING_CONSENT: 'Aceite de termos',
};

// Mapeamento de situação para classes CSS
const SITUATION_CLASS_MAP: { [key: string]: string } = {
  // Mapeamento por valor do enum (número)
  '1': 'situation-attention',
  '4': 'situation-approved',
  '5': 'situation-error',
  '6': 'situation-error',
  '7': 'situation-attention',
  '8': 'situation-attention',
  '9': 'situation-attention',
  '10': 'situation-attention',
  // Mapeamento por nome do enum (string)
  WAIT: 'situation-attention',
  APPROVED: 'situation-approved',
  REPROVED: 'situation-error',
  CANCELED: 'situation-error',
  IN_PROGRESS_REGISTER_MANAGEMENT: 'situation-attention',
  SENDING_REGISTRATION_REGISTER_MANAGEMENT: 'situation-attention',
  PENDING: 'situation-attention',
  AWAITING_CONSENT: 'situation-attention',
};

export function getStatusLabel(status: string): string {
  if (!status) return 'Desconhecido';
  return STATUS_LABEL_MAP[status] || status;
}

export function getStatusClass(status: string): string {
  if (!status) return '';
  return STATUS_CLASS_MAP[status] || '';
}

export function getSituationIcon(situation: number | string): string {
  if (!situation) return '';
  return SITUATION_ICON_MAP[situation.toString()] || '';
}

export function getSituationLabel(situation: number | string): string {
  if (!situation) return '';
  return SITUATION_LABEL_MAP[situation.toString()] || '';
}

export function getSituationClass(situation: number | string): string {
  if (!situation) return '';
  return SITUATION_CLASS_MAP[situation.toString()] || '';
}

export const ClientStatusUtil = {
  getStatusLabel,
  getStatusClass,
  getSituationIcon,
  getSituationLabel,
  getSituationClass,
};
